<template>
<div class="footer" v-show="appFlag">
  <div class="footerDivisionLine"></div>
  <div></div>
  <div class="footer-inner">
    <div v-html="bottomLink" class="footercent"></div>
    <div class="footercent">技术支持：深圳市学堂科技有限公司</div>
    <div class="footerbottom">
      <div style=" padding-bottom:5px ;">今日访问人数：{{dayCount}}</div>
      <div>总计访问人数：{{allCount}}</div>
    </div>
  </div>
</div>
</template>

<script>
import {getWebCountTJ}  from '@/api/clientshome/index.js';
export default {
  data() {
    return {
      bottomLink: localStorage.getItem('bottomLink'),
      appFlag: true,
      allCount:0,
      dayCount:0,
    };
  },
  created() {
     getWebCountTJ()
        .then((res) => {
          //console.log(res.result);
          this.allCount=res.result.allCount;
          this.dayCount=res.result.dayCount;
        });
  },
  watch: {
    $route: function () {
      if (this.$route.name == 'AppStore') {
        this.appFlag = false;
      } else {
        this.appFlag = true;
      }
    },
  },
  methods: {
    wzdt() {
      window.open(
        'https://map.baidu.com/poi/%E4%BA%BA%E6%B0%91%E5%A4%A7%E5%8E%A6/@12696654.990794068,2560694.219414985,20.97z?uid=ffd6d4037c27668f17b54b0c&info_merge=1&isBizPoi=false&ugc_type=3&ugc_ver=1&device_ratio=1&compat=1&querytype=detailConInfo&da_src=shareurl'
      );
    },
  },
};
</script>

<style lang="scss" scoped>
.footer {
  overflow: hidden;
  background-color: rgb(38, 38, 38);

  .footerDivisionLine{
    height: 3px;
    width: 1200px;
    margin: 0 auto;
    background-color: rgb(57, 56, 57);
    margin-bottom: 14px;
  }
  .footer-inner {
    width: 1200px;
    margin: 0 auto;
    padding: 10px 0 37px 0px;
    color: #b4b4b5;
    display: flex;
    justify-content: center;
    align-items: center;
    .footerbottom{
      display: flex;
      font-size: 16px;
      line-height: 24px;
      color: #b4b4b5;
      &>div:nth-child(1){
        margin-right: 20px;
      }
    }
  }
}
.footercent{
  flex: 1;
}

</style>
